// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"
import { useState, useEffect } from "react"
import { InputNumber } from "primereact/inputnumber"
import useDebounce from "../../helpers/useDebounce"

const TableInputNumberRange = ({
  onChange
}: any) => {
  const [value, setValue] = useState([null, null])
  const debouncedSearchTerm = useDebounce(value, 500)
  useEffect(() => {
    onChange(debouncedSearchTerm)
  }, [debouncedSearchTerm])
  return _jsxs(
    "div",
    {
      className: "g-number-range p-column-filter",
      style: { display: "flex", width: "100%", alignItems: "center" },
      children: [
        _jsx(
          InputNumber,
          {
            id: "range-lower",
            value: value[0] || undefined,
            onChange: (e: any) => {
              const [lower, upper] = value
              if (!lower || !e.value || (upper && e.value < upper))
                setValue([e.value, upper])
            },
          },
          void 0
        ),
        " - ",
        _jsx(
          InputNumber,
          {
            id: "range-upper",
            value: value[1] || undefined,
            onChange: (e: any) => {
              const [lower, upper] = value
              if (!upper || !e.value || (lower && e.value > lower))
                setValue([lower, e.value])
            },
          },
          void 0
        ),
      ],
    },
    void 0
  );
}
export default TableInputNumberRange
